import React, { Component } from 'react'

class Screen3A extends Component {

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>
        <label>{t(language, 'evidence')}
          <input type="file" onChange={(e) => addEntry('file', null, e)} />
        </label>
        <label>{t(language, 'internetUrl')}
          <input type="text" value={entry.url} onChange={(e) => addEntry('url', null, e)} />
        </label>
      </main>
    );
  }
}

export default Screen3A;
